import { useQueryState } from 'nuqs';
import { useState } from 'react';
import { useRecoilValue } from 'recoil';

import { RouteListGroup } from '@/components/modules/route/list-group';
import { DEFAULT_CARGO, DEFAULT_NUQS_CONFIG, MODE_AIR, ROUTE_SORT_TYPE_MATCH, SORTING } from '@/lib/constants';
import { routesCountState, routeSearchDestinationState, routeSearchOriginState, routesState } from '@/state/routes';
import { searchResultsLayoutState } from '@/state/search';
import { RouteSortTypes } from '@/types';
import { QUERY_PARAM } from '@/utils/helpers/api-urls/constants';
import { parseAsCargoOption } from '@/utils/nuqs/parse-as-cargo-option';
import { tv } from '@/utils/styles';

import { filterRoutes } from './utils/sort-and-filter-routes';

const RouteList = () => {
  const [sortingValue, setSortingValue] = useState<RouteSortTypes>(ROUTE_SORT_TYPE_MATCH);
  const layout = useRecoilValue(searchResultsLayoutState);
  const routes = useRecoilValue(routesState);
  const routesCount = useRecoilValue(routesCountState);
  const searchOrigin = useRecoilValue(routeSearchOriginState);
  const searchDestination = useRecoilValue(routeSearchDestinationState);
  const [cargo] = useQueryState(
    QUERY_PARAM.CARGO,
    parseAsCargoOption.withOptions(DEFAULT_NUQS_CONFIG).withDefault(DEFAULT_CARGO),
  );

  const primaryMode = layout.order[0].mode || [MODE_AIR];

  const { container } = styles();

  return (
    <div className={container()}>
      {routesCount > 0 && (
        <div>
          {layout.order.map((group) => {
            const groupRoutes = filterRoutes({
              routes,
              filterBy: group.mode,
              sortBy: {
                sort: sortingValue,
                order: SORTING.ASC,
              },
              originId: searchOrigin?.identifier?.value || '',
              destinationId: searchDestination?.identifier?.value || '',
            });

            return (
              <RouteListGroup
                key={group.groupKey}
                routes={groupRoutes}
                title={group.title}
                isHeroMode={primaryMode === group.mode}
                description={group.description}
                groupKey={group.groupKey}
                mode={group.mode[0]}
                containerSize={[cargo.containerSize!]}
                cargoWeight={cargo.weight!}
                defaultClosed={!group.open}
                sortingValue={sortingValue}
                onSortingValueChange={setSortingValue}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

const styles = tv({
  slots: {
    container: 'w-[calc(100%-1px)] px-0 px-4 py-4 max-md:px-0 md:w-full md:pb-10',
  },
});

export { RouteList };
